<template>
  <div class="game-mz-coloring-container" :style="getMainImg(startGameConfig.mainImage)">
    <div class="game-mz-coloring">
      <div class="box" :style="imageStyle">
        <img
          draggable="false"
          v-if="showTransparentImage"
          class="tr-image"
          @mousedown="clickOnCanvas"
          :src="getImageSrc(startGameConfig.image.trImage)"
        />
        <canvas
          ref="canvasImage"
          @mousedown="clickOnCanvas"
          :width="startGameConfig.image.width"
          :height="startGameConfig.image.height"
        ></canvas>
      </div>
      <palette
        @change-color="
          color = $event;
          startGameConfig.audio && startGameConfig.audio.click ? audioClick.play() : '';
        "
        :start-game-config="startGameConfig.palette"
      ></palette>
    </div>
  </div>
</template>

<script>
import { Howler } from 'howler';
import defaultMixin from '../../mixins/defaultMixin';
import palette from './palette';
export default {
  name: 'mz-coloring',
  mixins: [defaultMixin],
  components: {
    palette,
  },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      isFinished: false,
      gameState: false,
      canIFillAShape: true,
      showTransparentImage: false,
      color: '#ffffff',
      colors: [],
      canvasImage: {},
      canvasImageData: new Uint8ClampedArray(),
      canvasTemplateImageData: new Uint8ClampedArray(),
      canvasMaskData: new Uint8ClampedArray(),
      imageStyle: {},
      audioClick: null,
      audioNegative: null,
      audioPositive: null,
      audioColors: [],
    };
  },
  methods: {
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    getMainImg(mainImg) {
      if (mainImg && mainImg.imagePath) {
        return {
          ...{
            backgroundImage: `url('${this.getImageSrc(mainImg.imagePath)}')`,
          },
          ...this.getCustomStyle(mainImg),
        };
      }
      return this.getCustomStyle(mainImg);
    },
    getImageSrc(imageSrc) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${imageSrc}`);
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        let cnv = document.createElement('canvas'),
          img = new Image(),
          ctx = cnv.getContext('2d');
        cnv.width = this.startGameConfig.image.width;
        cnv.height = this.startGameConfig.image.height;
        img.src = this.getImageSrc(url);
        img.addEventListener('load', () => {
          ctx.drawImage(img, 0, 0);
        });
        img.onload = () =>
          resolve(ctx.getImageData(0, 0, this.startGameConfig.image.width, this.startGameConfig.image.height));
        img.onerror = () => reject(console.log('Error loading image'));
      });
    },
    hex2Rgb(hex) {
      return {
        r: (hex >> 16) & 0xff,
        g: (hex >> 8) & 0xff,
        b: hex & 0xff,
      };
    },
    rgb2hex(rgb) {
      return '#' + [rgb.r, rgb.g, rgb.b].map((c) => c.toString(16)).join('');
    },
    clickOnCanvas(event) {
      let x = event.offsetX,
        y = event.offsetY,
        gray = this.canvasMaskData.data[y * this.startGameConfig.image.width * 4 + x * 4 + 1],
        color = {
          r: this.canvasImageData.data[y * this.startGameConfig.image.width * 4 + x * 4],
          g: this.canvasImageData.data[y * this.startGameConfig.image.width * 4 + x * 4 + 1],
          b: this.canvasImageData.data[y * this.startGameConfig.image.width * 4 + x * 4 + 2],
        },
        isCorrect = true;
      this.fillShape(gray, color);
      for (let [i, e] of this.colors.entries()) {
        if (e.toLowerCase() != this.startGameConfig.image.colors[i + 1].toLowerCase()) {
          isCorrect = false;
          break;
        }
      }
      this.gameState = isCorrect;
      if (this.isFinished == false && isCorrect == true) {
        this.canIFillAShape = false;
        this.$store.dispatch('checkGame');
      }
      this.isFinished = isCorrect;
    },
    fillShape(gray, previousColor) {
      if (this.canIFillAShape) {
        let color = this.startGameConfig.image.colors[gray];
        if (color != '#000000') {
          this.canIFillAShape = false;
          const { data } = this.canvasMaskData;
          const { data: paintData } = this.canvasImageData;
          this.colors[gray - 1] = this.color;
          let newColor = this.hex2Rgb(parseInt(this.color.slice(1, 7), 16));
          for (let i = 0; i < data.length; i += 4) {
            if (data[i] == gray) {
              paintData[i] = newColor.r;
              paintData[i + 1] = newColor.g;
              paintData[i + 2] = newColor.b;
            }
          }
          this.canvasImage.putImageData(this.canvasImageData, 0, 0);
          if (this.startGameConfig.blockWrongColor) {
            if (this.color != this.startGameConfig.image.colors[gray]) {
              this.colors[gray - 1] = this.rgb2hex(previousColor);
              if (this.startGameConfig.audio && this.startGameConfig.audio.negative) {
                this.audioNegative.play();
                setTimeout(() => {
                  for (let i = 0; i < data.length; i += 4) {
                    if (data[i] == gray) {
                      paintData[i] = previousColor.r;
                      paintData[i + 1] = previousColor.g;
                      paintData[i + 2] = previousColor.b;
                    }
                  }
                  this.canvasImage.putImageData(this.canvasImageData, 0, 0);
                  this.canIFillAShape = true;
                }, this.audioNegative.duration() * 1000 + 100);
              } else {
                for (let i = 0; i < data.length; i += 4) {
                  if (data[i] == gray) {
                    paintData[i] = previousColor.r;
                    paintData[i + 1] = previousColor.g;
                    paintData[i + 2] = previousColor.b;
                  }
                }
                this.canvasImage.putImageData(this.canvasImageData, 0, 0);
                this.canIFillAShape = true;
              }
            } else {
              if (this.startGameConfig.audio && this.startGameConfig.audio.positive) {
                this.audioPositive.play();
              } else {
                if (this.audioColors.length > 0)
                  this.audioColors
                    .filter((e) => {
                      return e.id == this.color;
                    })
                    .map((e) => e.audio)[0]
                    .play();
              }
              this.canIFillAShape = true;
            }
          } else {
            this.canIFillAShape = true;
          }
        }
      }
    },
    checkGameAction() {
      return this.gameState;
    },
    resetGameAction() {
      this.canvasImage.clearRect(0, 0, this.startGameConfig.image.width, this.startGameConfig.image.height);
      this.canvasImage.putImageData(this.canvasTemplateImageData, 0, 0);
      this.canvasImageData = this.canvasImage.createImageData(
        this.startGameConfig.image.width,
        this.startGameConfig.image.height
      );
      this.canvasImageData.data.set(this.canvasTemplateImageData.data);
      this.colors.forEach((e, i) => {
        this.colors[i] = '#ffffff';
      });
      this.colors[0] = '#000000';
      if ('defaultColors' in this.startGameConfig.image) {
        this.startGameConfig.image.defaultColors.forEach((currentValue, index) => {
          if (currentValue != '') {
            this.colors[index] = currentValue;
          }
        });
      }
      this.canIFillAShape = true;
      this.gameState = false;
      this.isFinished = false;
    },
    giveMeAudioPlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setGameAudio() {
      for (let color of this.startGameConfig.palette.colors) {
        if (color.audio) {
          this.audioColors.push({
            id: color.val,
            audio: new Howl({
              src: this.giveMeAudioPlease(color.audio),
              autoplay: false,
              loop: false,
              volume: 0.5,
            }),
          });
        }
      }
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.positive) {
          this.audioPositive = new Howl({
            src: this.giveMeAudioPlease(this.startGameConfig.audio.positive),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.click) {
          this.audioClick = new Howl({
            src: this.giveMeAudioPlease(this.startGameConfig.audio.click),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.negative) {
          this.audioNegative = new Howl({
            src: this.giveMeAudioPlease(this.startGameConfig.audio.negative),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
      }
    },
  },
  computed: {
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
  created() {
    if (this.startGameConfig.image.trImage) {
      this.showTransparentImage = true;
    }
    this.loadImage(this.startGameConfig.image.srcMask).then((data) => {
      return (this.canvasMaskData = data);
    });
    this.loadImage(this.startGameConfig.image.srcImage).then((data) => {
      return (this.canvasImageData = data);
    });
    this.loadImage(this.startGameConfig.image.srcImage).then((data) => {
      return (this.canvasTemplateImageData = data);
    });
  },
  beforeMount() {
    this.imageStyle = this.startGameConfig.image.cssStyle;
  },
  mounted() {
    this.setGameAudio();
    this.canvasImage = this.$refs.canvasImage.getContext('2d');
    let image = new Image();
    image.src = this.getImageSrc(this.startGameConfig.image.srcImage);
    image.addEventListener('load', () => {
      this.canvasImage.drawImage(image, 0, 0);
    });
    this.colors = Array.from(
      {
        length: Object.keys(this.startGameConfig.image.colors).length,
      },
      () => '#ffffff'
    );
    this.colors[0] = '#000000';
    if ('defaultColors' in this.startGameConfig.image) {
      this.startGameConfig.image.defaultColors.forEach((currentValue, index) => {
        if (currentValue != '') {
          this.colors[index] = currentValue;
        }
      });
    }
    this.color = '#ffffff';
    if ('firstColor' in this.startGameConfig.palette) {
      this.color = this.startGameConfig.palette.firstColor;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$backgroundWidth: 1920px;
$backgroundHeight: 1080px;
$backgroundOffsetTop: 0;
$backgroundOffsetLeft: 0;
.game-mz-coloring-container {
  height: 100%;
  width: 100%;
}
.game-mz-coloring {
  position: absolute;
  display: flex;
  top: $backgroundOffsetTop;
  left: $backgroundOffsetLeft;
  height: $backgroundHeight;
  width: $backgroundWidth;
  overflow: hidden;
}
.tr-image {
  position: absolute;
}
</style>
